import script from "./ChamadasInstrutor.vue?vue&type=script&setup=true&lang=js"
export * from "./ChamadasInstrutor.vue?vue&type=script&setup=true&lang=js"

import "./ChamadasInstrutor.vue?vue&type=style&index=0&id=df458b16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df458b16"]])

export default __exports__